import { Record as record} from 'immutable';

import { construct, fields } from '../../../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../helpers/Records';
import {
    KeyGoProductStatus,
    keyGoPaymentCardStatus
} from '../../../constants/AppConstants';


const schema = {
    enabled: [ fields.boolean ],
    status: [ fields.string ],
    incompleteJourneys: [ fields.boolean ],
    paymentCardStatus: [ fields.string ],
    manualFillCount: [ fields.number ],
    balance: [ fields.number ]
};


class KeyGo extends record(getDefaults(schema)) {
    static fromJSON(json) {
        return construct(KeyGo, json, getResolvers(schema));
    }

    isActive () {
        return KeyGoProductStatus.LIVE === this.status;
    }

    isPending () {
        return KeyGoProductStatus.PENDING === this.status;
    }

    isPendingClosure () {
        return KeyGoProductStatus.PENDING_CLOSURE === this.status;
    }

    isClosed () {
        return KeyGoProductStatus.CLOSED === this.status;
    }

    hasIncompleteJourneys () {
        return this.get('incompleteJourneys');
    }

    getBalance () {
        return this.get('balance');
    }

    hasNegativeBalance () {
        return this.getBalance() < 0;
    }

    getPaymentCardStatus () {
        return this.get('paymentCardStatus');
    }

    isPaymentCardPending () {
        return this.getPaymentCardStatus() === keyGoPaymentCardStatus.EXPIRES_THIS_MONTH;
    }

    isPaymentCardExpired () {
        return this.getPaymentCardStatus() === keyGoPaymentCardStatus.EXPIRED;
    }

    isPaymentCardExpiredOrAboutTo () {
        return this.isPaymentCardPending() || this.isPaymentCardExpired();
    }

    hasNoPaymentCard () {
        return this.getPaymentCardStatus() === null;
    }

}


export default KeyGo;
